import { SUPPORTED_LANGS, EN, RTL, LTR } from './constants';

export function getLocaleAndDir(params: URLSearchParams) {
  let locale = params.get('lang') || EN;

  if (!SUPPORTED_LANGS.includes(locale)) {
    locale = EN;
  }

  const rtl = params.get(RTL) === 'true';
  const dirAttribute = rtl ? RTL : LTR;

  return { locale, dirAttribute };
}
